document.addEventListener('DOMContentLoaded', () => {
  const textLimitElements = document.querySelectorAll('.text-limit');

  // 元のテキストを保持しておく（トリミング処理を繰り返さないため）
  textLimitElements.forEach((el) => {
    el.setAttribute('data-original-text', el.textContent.trim());
  });

  // ★ itemList用の要素も取得し、data-original-textを保持
  const itemListElements = document.querySelectorAll('.itemList a p:nth-child(2)');
  itemListElements.forEach((el) => {
    el.setAttribute('data-original-text', el.textContent.trim());
  });

  // ★ related_unit用の要素も取得し、data-original-textを保持
  const relatedUnitElements = document.querySelectorAll('.related_unit p');
  relatedUnitElements.forEach((el) => {
    el.setAttribute('data-original-text', el.textContent.trim());
  });

  const getCharLimit = () => {
    const width = window.innerWidth;
    if (width <= 576) {
      return 35;
    } else if (width <= 768) {
      return 50;
    } else if (width <= 1010) {
      return 80;
    } else {
      return 100;
    }
  };

  const applyTextLimit = () => {
    const charLimit = getCharLimit();
    textLimitElements.forEach((el) => {
      const originalText = el.getAttribute('data-original-text');
      if (originalText.length > charLimit) {
        el.textContent = originalText.slice(0, charLimit) + '...';
      } else {
        el.textContent = originalText;
      }
    });

    // ★ itemList の要素には固定で10文字制限を適用
    itemListElements.forEach((el) => {
      const originalText = el.getAttribute('data-original-text');
      const itemCharLimit = 9;
      if (originalText.length > itemCharLimit) {
        el.textContent = originalText.slice(0, itemCharLimit) + '…';
      } else {
        el.textContent = originalText;
      }
    });

  // ★ related_unit の要素には固定で30文字制限を適用
  relatedUnitElements.forEach((el) => {
    const originalText = el.getAttribute('data-original-text');
    const relatedCharLimit = 25;
    if (originalText.length > relatedCharLimit) {
      el.textContent = originalText.slice(0, relatedCharLimit) + '…';
    } else {
      el.textContent = originalText;
    }
  });

  };

  // 初回実行
  applyTextLimit();

  // リサイズ時にも実行（debounceで連続実行を防ぐ）
  let resizeTimeout;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => {
      applyTextLimit();
    }, 150); // 150ms 後に実行
  });
});
